let MOCK_BASE_URL = process.env.REACT_APP_MOCK_BASE_URL || '';

const Config = {
  appName: 'Sharepoint',
  appTitle: 'ServerChameleon, by ServerPoint.com',
  apiTimeout: 30000,
  mockBaseURL: MOCK_BASE_URL,
  accessTokenLocalStoreKey: 'access_token',
};

export default Config;
